import React from "react";
import "./TimesheetStatus.css";

const TimesheetStatusPending = ({ className = "" }) => (
  <span className={`timesheets__status-pending ${className}`}>PENDING</span>
);

const TimesheetStatusApproved = ({ className = "" }) => (
  <span className={`timesheets__status-approved ${className}`}>APPROVED</span>
);

const TimesheetStatusRejected = ({ className = "" }) => (
  <span className={`timesheets__status-rejected ${className}`}>REJECTED</span>
);

const TimesheetStatus = ({ status, className = "" }) => {
  switch (status) {
    case "Approved":
      return <TimesheetStatusApproved className={className} />;
    case "Rejected":
      return <TimesheetStatusRejected className={className} />;
    case "Pending":
      return <TimesheetStatusPending className={className} />;
    default:
      return <></>;
  }
};

export default TimesheetStatus;
